import { env } from 'config';

const withPublicUrl = (url: string) => env.publicUrl + url;

export const ROUTE_PATH = {
  ORDER: withPublicUrl('/order/:id/:token'),
  DEEPLINK: withPublicUrl('/deeplink/:id/:token'),
  HELP: withPublicUrl('/help'),
};
